const routes = [
    {
        path: "/scholarshiptypes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "scholarshiptype_index"
        },
        component_full_path: "scholarshiptypes/pages/Index"
    }
];

export default routes;
